import { Outlet } from "react-router-dom";
import { LoginLeftPane } from "../features/login/components/left-pane/left-pane.component";
import mrgLogo from "assets/images/mrg/logo_mrg_color_withtagline.png";
import AppFooter from "./components/app-footer/app-footer.component";

import './styles/login.layout.styles.scss';
import 'assets/styles/app.scss';
import {markdown} from "assets/js/drawdown";
import {useGetSettingsConfigQuery} from "lib/reducers/airtable.slice";


export default function LoginLayout() {
  const questMaintenanceAlert = useGetSettingsConfigQuery('maintenance_alert');

    return (
        <>
            <div className="app-container loginStuff">
                <div className="h-100-vh">
                    <div className="row h-100 no-gutters">
                        <div className="col-lg-4 d-none d-lg-block">
                            <LoginLeftPane />
                        </div>
                        <div className="col-lg-8 col-md-12 d-flex flex flex-column justify-content-between mh-100">
                            <div className="d-flex flex-grow-1 justify-content-center my-auto">
                                <div className="app-login-box col-lg-6 col-md-8 col-sm-12 d-flex flex-column justify-content-center mx-auto pt-3 text-center">
                                    <div className="loginHeader pb-5">
                                      {!questMaintenanceAlert.isLoading && questMaintenanceAlert.data && questMaintenanceAlert.data.records.length > 0 &&
                                        <div className="alert alert-danger mx-auto w-80p">
                                          {<span dangerouslySetInnerHTML={{__html: markdown(questMaintenanceAlert.data.records[0].fields.value)}}></span>}
                                        </div>
                                      }
                                        <a href="http://www.mrg.com" target="_blank" rel="noopener noreferrer">
                                            <img className="mrgLogo" src={mrgLogo} alt="Quest : Powered by MRG" />
                                        </a>
                                    </div>

                                    {/* User Login-related Pages */}
                                    <Outlet />
                                </div>
                            </div>
                            <AppFooter isCompact={true} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
